export default "__VITE_ASSET__DN7SH9cF__"